module.exports = __webpack_public_path__ + "media/sound-baskett.a7b28185.wav";